import { createContext } from 'react';

import { BaseColors, Color, TabVariant } from '@UI/lib/utils';

const BaseColorContext = createContext<Color | undefined>(BaseColors.Indigo);

const TabVariantContext = createContext<TabVariant>('line');

const IndexContext = createContext<number>(0);

interface SelectedValueContextValue {
  selectedValue: any;
  handleValueChange?: (value: any) => void;
}
const SelectedValueContext = createContext<SelectedValueContextValue>({
  selectedValue: undefined,
  handleValueChange: undefined,
});

export {
  BaseColorContext,
  TabVariantContext,
  IndexContext,
  SelectedValueContext,
  type SelectedValueContextValue,
};
